import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable()
export class FilterChangedService {
    public filterChanged$: Observable<void>;
    // Used to propagate the information that filter changed from grid-analytics.effects to grid-result-search-header.component
    private fromEffectToSearchHeader = new Subject<void>();

    constructor() {
        this.filterChanged$ = this.fromEffectToSearchHeader.asObservable();
    }

    public filterChange(): void {
        this.fromEffectToSearchHeader.next();
    }
}
